import { createFileRoute, Link } from '@tanstack/react-router';
import { useEffect } from 'react';
import { FiArrowRight } from 'react-icons/fi';
import { Footer, MarketingHeader, SEO } from '@/components';
import { CHECK_QUIZZES, CHECK_SLUGS } from '@/lib/check/quizzes';
import { track } from '@/lib/analytics';

const nunito = {
  fontFamily:
    "'Nunito', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
};

function CheckHubPage() {
  useEffect(() => {
    track('Check Hub View');
  }, []);

  return (
    <div className='min-h-screen bg-white'>
      <SEO
        title='Harbor Checks | Co-parent identity quizzes'
        description='Four taps. See where you sit next to other parents on time, money, and communication. No account, no names.'
        path='/check'
      />
      <MarketingHeader />
      <section className='bg-primary/5 pt-32 pb-12'>
        <div className='mx-auto max-w-3xl px-6 text-center'>
          <p
            className='mb-2 text-xs font-semibold uppercase tracking-wide text-primary'
            style={nunito}
          >
            Before you start
          </p>
          <h1
            className='mb-4 text-4xl font-bold text-gray-900 md:text-5xl'
            style={{ ...nunito, fontWeight: 700 }}
          >
            Harbor checks
          </h1>
          <p className='text-lg text-gray-600' style={nunito}>
            Four taps. A card you can share. We never ask for names.
          </p>
        </div>
      </section>
      <div className='mx-auto max-w-3xl px-6 py-12'>
        <div className='grid gap-4'>
          {CHECK_SLUGS.map((slug) => {
            const quiz = CHECK_QUIZZES[slug];
            return (
              <Link
                key={slug}
                to='/check/$quiz'
                params={{ quiz: slug }}
                className='group rounded-2xl border border-gray-200 bg-white p-6 shadow-sm transition-shadow hover:shadow-md'
              >
                <h2
                  className='text-xl font-bold text-gray-900'
                  style={{ ...nunito, fontWeight: 700 }}
                >
                  {quiz.title}
                </h2>
                <p className='mt-2 text-gray-600' style={nunito}>
                  {quiz.tagline}
                </p>
                <span className='mt-4 inline-flex items-center gap-2 font-semibold text-primary'>
                  Take this check <FiArrowRight className='transition-transform group-hover:translate-x-0.5' />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export const Route = createFileRoute('/check/')({
  component: CheckHubPage,
});
